export default {
  have_account: 'Hai un account?',
  sign_in: 'Accedi',
  sign_in_description: 'per usare i tuoi punti e i dati salvati',
  join_free: 'Iscriviti gratis',
  join_description: '— guadagna premi su ogni ordine',
  join_description_with_discount: `— guadagna premi fino a <highlight>{{max_discount}} di sconto</highlight> su ogni ordine`,
  join_description_with_product_and_discount: `— guadagna premi come {{product_name}} gratis e fino a <highlight>{{max_discount}} di sconto</highlight> su ogni ordine`,
  demo_mode: 'Modalità demo',
};
